import { Gauge, Rocket, ShieldCheck } from "lucide-react";
import { formatCurrency } from "../../../../format";
import type { MarketStrategy } from "../../domain/types";

const strategyIcons = { "quick-sale": Rocket, recommended: ShieldCheck, "market-test": Gauge } as const;

export function StrategyStep({ strategies }: { strategies: MarketStrategy[] }) {
  return (
    <div className="market-step-content">
      <div className="market-step-intro">
        <p className="market-kicker">Cenová stratégia</p>
        <h2>Tri pracovné scenáre</h2>
        <p>Každá cena je odvodená z rovnakého trhového pásma, bez predstieranej presnosti.</p>
      </div>
      <div className="market-strategy-list">
        {strategies.map((strategy) => {
          const Icon = strategyIcons[strategy.kind];
          return (
            <article className={`market-strategy-card ${strategy.kind === "recommended" ? "featured" : ""}`} key={strategy.kind}>
              <Icon size={20} aria-hidden="true" />
              <div><span>{strategy.title}</span><strong>{formatCurrency(strategy.listingPrice)}</strong><p>{strategy.explanation}</p></div>
            </article>
          );
        })}
      </div>
      <div className="market-methodology-note">Metodika CMA-0.1 · deterministický výpočet · snapshot po finalizácii</div>
    </div>
  );
}
